module.exports = __webpack_public_path__ + "static/img/14-3.602782c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/14-3.jpg
// module id = CkeF
// module chunks = 0